import { investmentEntity } from '@store/modules/investment-entity';
import { ipo } from '@store/modules/ipo';
import { RouteConfig } from 'vue-router';
import { upgrade } from '@store/modules/upgrade';

const offeringsRoutes: Array<RouteConfig> = [
	{
		path: `/offerings`,
		name: 'offerings',
		component: () => import(/* webpackChunkName: "offerings" */ '@views/offerings/offerings.vue')
	},
	{
		path: '/offerings/fundrise-ipo/view',
		name: 'offerings-ipo-landing',
		component: () =>
			import(/* webpackChunkName: "offerings-ipo-landing" */ '@views/offerings/offerings-ipo-landing.vue'),
		beforeEnter: async (to, from, next) => {
			if (investmentEntity.isIraEntity) {
				next({ name: 'account-overview', replace: true });
			} else if (investmentEntity.hasNeverBeenAnInvestor) {
				next({ name: 'user-overview', replace: true });
			} else {
				await ipo.fetchAndStoreMetadata();
				await ipo.fetchAndStoreServiceLevelPrincipal();

				if (!upgrade.dataLoaded) {
					await upgrade.fetchAndStoreServiceLevelUpgradeData();
				}
				next();
			}
		}
	}
];

export default offeringsRoutes;
